import React, { Component } from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import styled from "styled-components";
import { Link } from "react-router-dom";

class ModelWakel extends Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const {
            RW_modalOpen,
            RW_CloseModal,
            Rw_serchwakil,
            RW_jwalakan,
            AddProChange,
            RW_zh_barez,
            RW_nawibrez,
            RW_from,
            RW_to,
            RW_setstInputEmpty,
            RW_wakilSuggestions,
            RW_wakilCursor,
            RW_wakilNameHandle,
            RW_wakilListKeydown,
            RW_wakilSuggestionSelected
          } = value;

          if (!RW_modalOpen) {
            return null;
          } else {
            return (
              <ModalContainer>
                <div className="container">
                  <div className="row">
                    <div
                      id="modal"
                      className="col-8 mx-auto col-10 col-lg-6 text-center text-capitalize p-5"
                    >
                      <div className="row">
                        <div className="col-12 mb2">
                          <h3>ڕاپۆرتی وەکیل</h3>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              onChange={RW_wakilNameHandle}
                              name="RW_nawibrez"
                              onKeyDown={RW_wakilListKeydown}
                              onKeyPress={(event) =>
                                event.key == "Enter"
                                  ? Rw_serchwakil(event)
                                  : null
                              }
                              autoComplete="off"
                              placeholder="ناوی وەکیل"
                              value={RW_nawibrez}
                              className="form-control"
                            />
                            {RW_wakilSuggestions &&
                              RW_wakilSuggestions.length !== 0 && (
                                <ul
                                  dir="rtl"
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    maxHeight: "250px",
                                    overflowY: "auto",
                                    zIndex: 1100,
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                    borderRadius: "4px",
                                    marginTop: "2px"
                                  }}
                                  className="list-group"
                                >
                                  {RW_wakilSuggestions.map((item, idx) => (
                                    <li
                                      className="list-group-item"
                                      key={item._id || idx}
                                      onClick={() =>
                                        RW_wakilSuggestionSelected(item)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px 12px",
                                        borderBottom: "1px solid #dee2e6",
                                        textAlign: "right",
                                        color: "#000",
                                        backgroundColor:
                                          RW_wakilCursor === idx
                                            ? "#d4e9ff"
                                            : "#fff"
                                      }}
                                    >
                                      <div className="font-weight-bold">
                                        {item.Name}
                                      </div>
                                      <small
                                        dir="ltr"
                                        style={{
                                          display: "block",
                                          textAlign: "right",
                                          color: "#6c757d"
                                        }}
                                      >
                                        {item.code} | {item.phone}
                                      </small>
                                    </li>
                                  ))}
                                </ul>
                              )}
                          </div>
                        </div>
                        <div className="col-3">
                          <input
                            type="text"
                            onChange={AddProChange}
                            onClick={RW_setstInputEmpty}
                            name="RW_zh_barez"
                            onKeyPress={(event) =>
                              event.key == "Enter" ? Rw_serchwakil(event) : null
                            }
                            value={RW_zh_barez == 0 ? "" : RW_zh_barez}
                            className="form-control"
                          />
                        </div>
                        <div className="col-3">
                          <label className="text-danger f4 font-weight-bold">
                            وەکیل
                          </label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="form-group">
                            <label className="text-danger f4 font-weight-bold">
                              هەتاوەکو
                            </label>
                            <br />
                            <input
                              type="date"
                              onChange={AddProChange}
                              name="RW_to"
                              value={RW_to}
                              className="selectpicker btn btn-dark"
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label className="text-danger f4 font-weight-bold">
                              لە
                            </label>
                            <br />
                            <input
                              type="date"
                              onChange={AddProChange}
                              name="RW_from"
                              value={RW_from}
                              className="selectpicker btn btn-dark"
                            />
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-6">
                          <Link to="/Product-Raport">
                            <button
                              className="btn btn-danger"
                              onClick={() => RW_CloseModal()}
                            >
                              چوونەدەرەوە
                            </button>
                          </Link>
                        </div>
                        <div className="col-6">
                          <Link to="/Raport-wakel">
                            <button
                              className="btn btn-success px-4"
                              onClick={(e) => {
                                RW_jwalakan(e);
                              }}
                            >
                              هەموو جووڵەکان
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalContainer>
            );
          }
        }}
      </ProductConsumer>
    );
  }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  #modal {
    background: #f3e29f;
  }
`;

export default ModelWakel;
